import React, { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Icon } from "@iconify/react";
import { Tooltip } from "@mui/material";
import { useContentSetting } from "../../../Hooks/ContentSetting";
import { usePortalBrand } from "../../../Hooks/usePortalBrand";
import moment from "moment";
import { useClassRoom } from "../../../Hooks/ClassRoom";
import { formatTime } from "../../../utils/classRoomUtils";

export default function ParticipantView(props) {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const {
    remoteStreams,
    isPaused,
    selectedUser,
    localUser,
    isSharedScreen,
    remoteUser,
  } = useClassRoom();
  const localStream = localUser.stream;
  const isMuted = remoteUser?.isMuted;
  const remoteStream =
    remoteStreams?.length > 0 ? remoteStreams[0].stream : null;

  const { startedMeeting, userInfo } = useContentSetting();
  const { brandLogoUrl, brandName } = usePortalBrand();
  const isStudent = userInfo.user_type === "student";

  const { setBoxType, boxType } = props;

  let total_time = 0;
  if (startedMeeting) {
    const startTime = moment(startedMeeting.call_started_time);
    const endTime = moment(new Date());
    total_time = endTime.diff(startTime, "seconds");
  }
  const [timer, setTimer] = useState(total_time);

  const handleCloseBox = () => setBoxType("CIRCLE");

  useEffect(() => {
    if (!videoRef.current) return;
    if (isSharedScreen) {
      videoRef.current.srcObject = remoteStream;
    } else {
      const stream = isStudent ? localStream : remoteStream;
      videoRef.current.srcObject = stream;
    }
  }, [isSharedScreen, localStream, remoteStream, isStudent]);

  useEffect(() => {
    const audioEl = audioRef.current;
    if (!audioEl || !remoteStream) return;
    audioEl.srcObject = remoteStream;
    const play = audioEl.play();
    if (play?.catch) play.catch(() => {});
  }, [remoteStream]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="meeting-wrapper">
      {boxType === "CIRCLE" ? (
        <div className="change-call-view" onClick={handleCloseBox}>
          <Tooltip title={`Open Call Tools`}>
            <Icon
              fontSize="18"
              className="start-call-icon"
              icon={`ic:sharp-open-with`}
            />
          </Tooltip>
        </div>
      ) : (
        <div className="meeting-top-section">
          <div className="change-call-view" onClick={handleCloseBox}>
            <Tooltip title={`Close Box`}>
              <Icon
                fontSize="18"
                className="start-call-icon"
                icon={`ic:baseline-close`}
              />
            </Tooltip>
          </div>
          <div className="call-timer-section">
            <div className="call-timer-box">{formatTime(timer)}</div>
          </div>
          <div
            className="change-call-view"
            onClick={() => setBoxType(boxType === "BOX" ? "FULL" : "BOX")}
          >
            <Tooltip title={`${boxType === "BOX" ? "Full View" : "Box View"}`}>
              <Icon
                fontSize="18"
                className="start-call-icon"
                icon={`${
                  boxType === "BOX"
                    ? "majesticons:open"
                    : "mdi:arrow-collapse-all"
                }`}
              />
            </Tooltip>
          </div>
        </div>
      )}
      <video ref={videoRef} autoPlay playsInline className="w-100" muted />
      <audio ref={audioRef} autoPlay playsInline />
      {isPaused && !(isSharedScreen && isStudent) && boxType !== "CIRCLE" && (
        <>
          {!isStudent && (
            <div className="student-calling-name">
              {isMuted && (
                <Icon
                  fontSize="18"
                  className="start-call-icon"
                  icon={`vaadin:mute`}
                />
              )}
              {selectedUser.name}
            </div>
          )}
          <div className="image-logo-box">
            {brandLogoUrl ? (
              <>
                <img src={brandLogoUrl} alt="" loading="lazy" decoding="async" />
                {brandName ? (
                  <p className="mb-0 mt-1 text-white text-center w-100 px-1 small">{brandName}</p>
                ) : null}
              </>
            ) : brandName ? (
              <p className="mb-0 text-white text-center w-100 px-1">{brandName}</p>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
}
